export default __webpack_public_path__ + "static/media/workouttimes_2.2152daf0.jpg";